@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.areas
import com.narbase.letsgo.dto.core.KmmLong
data class AreaDto(
    val id: KmmLong?,
    val name: String,
)